var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6206 5.04419C15.0659 4.59888 15.2275 3.94335 15.04 3.34218C14.8526 2.74101 14.3469 2.29486 13.7276 2.18109C10.0096 1.49816 6.03634 2.72137 3.66059 6.28463C1.46645 9.57547 1.44341 14.0075 3.61075 17.3161C7.28694 22.9279 14.8935 23.4971 19.3668 19.0236C21.7845 16.606 22.3402 13.612 21.8121 10.4791C21.5994 9.21671 20.0111 8.74815 19.1059 9.65338C17.9127 10.8465 16.3807 10.7983 15.0115 9.81224C13.2667 8.55571 13.1217 6.54296 14.5764 5.08827L14.6206 5.04419Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39094 11.1365C8.32633 11.1365 9.08461 10.3782 9.08461 9.44283C9.08461 8.50744 8.32633 7.74916 7.39094 7.74916C6.45556 7.74916 5.69728 8.50744 5.69728 9.44283C5.69728 10.3782 6.45556 11.1365 7.39094 11.1365Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58835 17.1244C9.52374 17.1244 10.282 16.3662 10.282 15.4308C10.282 14.4954 9.52374 13.7371 8.58835 13.7371C7.65297 13.7371 6.89469 14.4954 6.89469 15.4308C6.89469 16.3662 7.65297 17.1244 8.58835 17.1244Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5763 18.3223C15.5117 18.3223 16.27 17.564 16.27 16.6286C16.27 15.6932 15.5117 14.935 14.5763 14.935C13.6409 14.935 12.8826 15.6932 12.8826 16.6286C12.8826 17.564 13.6409 18.3223 14.5763 18.3223Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.27c755d3444fdd649a14e7236db45378.svg";
export { ForwardRef as ReactComponent };